import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import DiscountHeader, {DiscountHeaderCircle} from "../../icons/DiscountHeader";
import {useEffect, useState} from "react";
import {generateDiscountCode, toFarsiNumber} from "../../methods/CommonMethods";
import {CloseIcon, UploadIcon} from "../../icons/VectorIcons";
import {AdapterDateFnsJalali} from "@mui/x-date-pickers/AdapterDateFnsJalali";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {CalenderIcon} from "../../icons/VectorIcons";
import {InputError, notify} from "../../utils";
import {addDiscountCode, getDiscountCode, updateDiscountCode} from "../../../api/LeaderPortalApi";
import {Toaster} from "react-hot-toast";

export default function DiscountAddPopUp({open, setOpen, setLoadingPage, id, editable, setEditable}) {
    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'517px'
    })

    const dt = new Date();
    const [discountValue, setDiscountValue] = useState("")
    const [discountError, setDiscountError] = useState("")
    const [nationalCode, setNationalCode] = useState("")
    const [strings, setStrings] = useState(new Set());
    // const [nationalError, setNationalError] = useState("")
    const [countUsed, setCountUsed] = useState("")
    const [countUsedError, setCountUsedError] = useState("")
    const [discountPercent, setDiscountPercent] = useState("")
    const [discountPercentError, setDiscountPercentError] = useState("")
    const [dateFrom, setDateFrom] = useState(dt)
    const [dateFromError, setDateFromError] = useState("")
    const [dateTo, setDateTo] = useState(new Date().setMonth(dt.getMonth() + 1))
    const [dateToError, setDateToError] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    // const [activeBtn, setActiveBtn] = useState('PERSONALITY')
    // const [activeLabel, setActiveLabel] = useState('all')

    // useEffect(() => {
    //     if(activeLabel != "group") {
    //         setStrings([])
    //     }
    // }, [activeLabel])

    // const handleAddString = () => {
    //     if (nationalCode.trim() !== '') {
    //         setStrings(new Set([...strings, nationalCode]));
    //         setNationalCode('');
    //     }
    // };
    //
    // const handleRemoveString = (index) => {
    //     const newNationals = Array.from(strings);
    //     newNationals.splice(index, 1);
    //     setStrings(new Set(newNationals));
    // };
    //
    // const handleRemoveAllStrings = () => {
    //     setStrings(new Set());
    // };
    //
    // const handleUploadFile = () => {
    //     document.getElementById("documentUpload").click();
    // };

    // const uploadFile = (event) => {
    //     const file = event.target.files[0];
    //
    //     if (file && file.name.endsWith('.xlsx')) {
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             const data = new Uint8Array(e.target.result);
    //             const workbook = XLSX.read(data, { type: 'array' });
    //             const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    //             const sheetData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
    //
    //             // Assuming the data is in the first column
    //             const columnValues = sheetData.map(row => row[0]).filter(cell => typeof cell === 'number' || /^\d+$/.test(cell));
    //
    //             setStrings(new Set([...strings, ...columnValues.map(num => num.toString())]));
    //         };
    //         reader.readAsArrayBuffer(file);
    //     } else {
    //         alert('Please upload a valid xlsx file.');
    //     }
    //
    //     event.target.value = '';
    // }

    const handleRandom = () => {
        const code = generateDiscountCode(7);
        setDiscountValue(code);
    }

    const cancel = () => {
        setOpen(false);
        setDiscountValue("")
        setNationalCode("")
        setStrings(new Set())
        setDiscountError("")
        // setNationalError("")
        setCountUsedError("")
        setCountUsed("")
        setDiscountPercent("")
        setDiscountPercentError("")
        setDateFromError("")
        setDateToError("")
        setEditable(false)

    }

    const validate = () => {
        let res = true;
        if(discountValue.trim().length == 0) {
            setDiscountError("لطفا یک کد تخفیف وارد کنید.")
            res = false;
        }

        // if(activeLabel != "all" && (nationalCode.trim().length == 0 || strings.size == 0)) {
        //     setNationalError("کدملی / شناسه ملی را وارد کنید.")
        //     res = false;
        // }

        if(countUsed.trim().length == 0) {
            setCountUsedError("لطفا تعداد استفاده از این کد تخفیف را وارد کنید.")
            res = false;
        }

        if(discountPercent.trim().length == 0) {
            setDiscountPercentError("لطفا درصد کد تخفیف را وارد کنید.")
            res = false;
        }

        if(dateFrom === null) {
            setDateFromError("تاریخ شروع استفاده کد تخفیف را مشخص کنید.")
            res = false;
        }

        if(dateTo === null) {
            setDateToError("تاریخ انقضا کد تخفیف را مشخص کنید.")
            res = false;
        }

        return res;
    }

    async function onSubmit() {
        let res = await validate();
        if(res) {

            const dataToSend = {
                // certType: activeBtn,
                // nationalIdList: activeLabel === "one" ? [nationalCode] : Array.from(strings),
                countUsed: countUsed,
                endTime: dateTo,
                startTime: dateFrom,
                percent: discountPercent,
                value: discountValue,
            }
            setIsLoading(true)

            if(editable) {
                updateDiscountCode(dataToSend, id).then( response => {
                    cancel();
                    setLoadingPage(prev => !prev)
                    setIsLoading(false)
                    setOpen(false);
                }).catch(error => {
                    setIsLoading(false)
                    notify(error?.response?.data?.message)
                })

            }else {
                addDiscountCode(dataToSend).then( response => {
                    cancel();
                    setLoadingPage(prev => !prev)
                    setIsLoading(false)
                    setOpen(false);
                }).catch(error => {
                    setIsLoading(false)
                    notify(error?.response?.data?.message)
                })
            }
        }
    }

    useEffect(() => {
        setIsLoading(true)

        if(editable) {

            getDiscountCode(id).then( response => {
                const dtF = new Date(response?.data?.startTime)
                const dtT = new Date(response?.data?.endTime)
                setCountUsed((response?.data?.countUsed).toString())
                setDiscountValue(response?.data?.value)
                setDateFrom(dtF)
                setDateTo(dtT)
                setDiscountPercent((response?.data?.percent).toString())
                setIsLoading(false)
            }).catch( error => {
                setIsLoading(false)
                notify(error?.response?.data?.message)
            })
        }
        setIsLoading(false)
    }, [editable])

    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width p-0">
                <div className={`p-0 m-0 pb-5`} style={{position: "relative"}}>
                    <DiscountHeader />
                    <div className={`div_h_circle`}>
                        <DiscountHeaderCircle />
                    </div>
                </div>

                <p className={`text-center`}>
                    {
                        editable ? "ویرایش کد تخفیف" : "افزودن کد تخفیف جدید"
                    }
                </p>

                <div className={`row px-5 my-3`}>
                    <label className="form-label text-form-title p-0">عنوان کد تخفیف</label>
                    <div
                        className={`input-group ${discountError !== "" ? "input-group2-error" : "input-group2"} ltr p-0`}>
                        <span
                            className="input-group-text inputGroupText2"
                            style={{padding: "1.5% 2% 1.5% 0%"}}
                            id="basic-addon2">
                            <span
                                className={`pointer`}
                                onClick={handleRandom}
                            >
                                <button className={`btn btn-sm random-btn`}
                                >عنوان تصادفی</button>

                            </span>
                        </span>

                        <input type="text"
                               className={`formControl formControl-mod`}
                               placeholder="عنوان کد تخفیف را وارد کنید"
                               value={discountValue}
                               onChange={(e) => {
                                   setDiscountValue(e.target.value)
                                   setDiscountError("")
                               }}
                        />


                    </div>
                    {discountError && <InputError message={discountError} show={discountError.length > 0} />}
                </div>

                {/*<div className={`row px-5  my-3`}>*/}
                {/*    <div className={`d-flex ltr changeBtnStep`}>*/}
                {/*        <button*/}
                {/*            style={{fontSize: "0.85rem"}}*/}
                {/*            className={`btn ${activeBtn === 'COMPANY' ? 'activeDarkGreenBtn' : '' }`}*/}
                {/*            onClick={ () => setActiveBtn('COMPANY')}*/}
                {/*        >حقوقی</button>*/}

                {/*        <button*/}
                {/*            style={{fontSize: "0.85rem"}}*/}
                {/*            className={`btn ${activeBtn === 'PERSONALITY' ? 'activeDarkGreenBtn' : '' }`}*/}
                {/*            onClick={ () => setActiveBtn('PERSONALITY')}*/}
                {/*        >حقیقی</button>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className={`row px-5 mt-3 mb-1`}>*/}

                {/*    <div className={`d-flex justify-content-between p-0`}>*/}
                {/*        <label className="form-label text-form-title p-0 m-0">{activeBtn === 'COMPANY' ? 'شناسه ملی' : 'کدملی'}</label>*/}
                {/*        <div className={`d-flex changeBtnStep p-0`}>*/}
                {/*            <button*/}
                {/*                style={{fontSize: "0.6rem", borderRadius: "20px !important"}}*/}
                {/*                className={`btn py-0 ${activeLabel === 'all' ? 'activeDarkGreenBtn2' : '' }`}*/}
                {/*                onClick={ () => {*/}
                {/*                    setNationalError("")*/}
                {/*                    setActiveLabel('all')*/}
                {/*                }}*/}
                {/*            >همه</button>*/}

                {/*            <button*/}
                {/*                style={{fontSize: "0.6rem"}}*/}
                {/*                className={`btn py-0 ${activeLabel === 'one' ? 'activeDarkGreenBtn2' : '' }`}*/}
                {/*                onClick={ () => setActiveLabel('one')}*/}
                {/*            >تک</button>*/}

                {/*            <button*/}
                {/*                style={{fontSize: "0.6rem"}}*/}
                {/*                className={`btn py-0 ${activeLabel === 'group' ? 'activeDarkGreenBtn2' : '' }`}*/}
                {/*                onClick={ () => setActiveLabel('group')}*/}
                {/*            >گروه</button>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className={`input-group ${nationalError !== "" ? "input-group2-error" : "input-group2"} ltr p-0 mt-2`}>*/}
                {/*        {activeLabel === "group" ?*/}
                {/*            <span*/}
                {/*                className="input-group-text inputGroupText2"*/}
                {/*                style={{padding: "1.5% 2% 1.5% 0%"}}*/}
                {/*                id="basic-addon2">*/}
                {/*                <span*/}
                {/*                    className={`pointer`}*/}
                {/*                    onClick={handleRandom}*/}
                {/*                >*/}
                {/*                    <button onClick={handleAddString} className={`btn btn-sm add-btn`}*/}
                {/*                    >افزودن</button>*/}

                {/*                    <button className={`btn btn-sm random-btn ltr`} onClick={handleUploadFile}*/}
                {/*                    >*/}
                {/*                        Excel*/}
                {/*                        فایل*/}

                {/*                        <div className={`d-inline ms-1`}><UploadIcon /></div>*/}
                {/*                    </button>*/}

                {/*                    <input type={`file`} id={`documentUpload`} className={`d-none`} onChange={uploadFile}/>*/}

                {/*                </span>*/}
                {/*            </span>*/}
                {/*            :*/}
                {/*            <></>*/}
                {/*        }*/}

                {/*        <input type="text"*/}
                {/*               className={activeLabel === "group" ? `formControl formControl-mod` : "form-control formControl-mod2"}*/}
                {/*               placeholder={activeBtn === "COMPANY" ?  "شناسه ملی را وارد کنید" : " کد ملی را وارد کنید"}*/}
                {/*               value={nationalCode}*/}
                {/*               disabled={activeLabel === "all"}*/}
                {/*               dir={'auto'}*/}
                {/*               onChange={(e) => {*/}
                {/*                   setNationalCode(e.target.value)*/}
                {/*                   setNationalError("")*/}
                {/*               }}*/}
                {/*        />*/}

                {/*    </div>*/}
                {/*    {nationalError && <InputError message={nationalError} show={nationalError.length > 0} />}*/}
                {/*</div>*/}

                {/*<div className={`row mx-5 py-2 mb-3 ${Array.from(strings).length > 0 ? "listMenuDiv" : "mb-5 pb-4"}`}>*/}
                {/*    {*/}
                {/*        Array.from(strings).length > 0 && Array.from(strings).map( (str, index) => (*/}
                {/*            <div className={`col-3 mb-2 text-center`} style={{padding: "0 0.2rem"}}>*/}
                {/*                <span className={`listItemStr`}>*/}
                {/*                    {toFarsiNumber(str)}*/}
                {/*                    <span className={`pointer`}*/}
                {/*                          onClick={() => handleRemoveString(index)}*/}
                {/*                    ><CloseIcon /></span>*/}
                {/*                </span>*/}
                {/*            </div>*/}
                {/*        ))*/}
                {/*    }*/}
                {/*    {Array.from(strings).length > 0 && <div*/}
                {/*        className={`col-12 text-center pointer`}*/}
                {/*        style={{fontSize: "0.7rem"}}*/}
                {/*        onClick={handleRemoveAllStrings}*/}
                {/*    >حذف همه</div>}*/}
                {/*</div>*/}

                <div className={`row mx-5 justify-content-between`}>

                    <div className={`col-6 mb-3 p-0 ps-2`}>
                        <label className="form-label text-form-title p-0">تعداد استفاده</label>
                        <div className={`input-group ${countUsedError !== "" ? "input-group2-error" : "input-group2"} ltr p-0`}>
                        <span
                            className="input-group-text inputGroupText2"
                            style={{padding: "3% 5% 3% 5%"}}
                            id="basic-addon2">
                            <span>عدد</span>
                        </span>
                            <input type="text"
                                   className={`formControl formControl-mod p-2`}
                                   value={countUsed}
                                   onChange={(e) => {
                                       setCountUsedError("")
                                       setCountUsed(e.target.value)
                                   }}
                            />
                        </div>
                        {countUsedError && <InputError message={countUsedError} show={countUsedError.length > 0} />}
                    </div>

                    <div className={`col-6 mb-3 p-0 pe-2`}>
                        <label className="form-label text-form-title p-0">درصد کد تخفیف</label>
                        <div className={`input-group ${discountPercentError !== "" ? "input-group2-error" : "input-group2"} ltr p-0`}>
                        <span
                            className="input-group-text inputGroupText2"
                            style={{padding: "3% 5% 3% 5%"}}
                            id="basic-addon2">
                            <span>درصد</span>
                        </span>
                            <input type="text"
                                   className={`formControl formControl-mod p-2`}
                                   value={discountPercent}
                                   onChange={(e) => {
                                       setDiscountPercentError("")
                                       setDiscountPercent(e.target.value)
                                   }}
                            />
                        </div>
                        {discountPercentError && <InputError message={discountPercentError} show={discountPercentError.length > 0} />}
                    </div>

                    <div className={`col-6 mb-3 p-0 ps-2`}>
                        <label className="form-label text-form-title p-0">تاریخ شروع</label>
                        <LocalizationProvider dateAdapter={AdapterDateFnsJalali} >
                            <DesktopDatePicker
                                components={{
                                    openPickerIcon: CalenderIcon,
                                }}
                                sx={{"&.MuiInputBase-root":{
                                    borderRadius:"10px",
                                    height:"44px",
                                    direction:"ltr",
                                }}}
                                className={` ${ dateFromError !== "" ? "input-br-error" : ""}`}
                                slotProps={{
                                    textField:{fullWidth:true,size:"small",sx:{borderRadius:"10px","& .MuiInputBase-root":{borderRadius:"10px",height:"44px"}}}}}  value={dateFrom}
                                onChange={(newValue) => {
                                    setDateFromError("")
                                    setDateFrom(newValue)
                                }} />
                        </LocalizationProvider>
                        {dateFromError && <InputError message={dateFromError} show={dateFromError.length > 0} />}
                    </div>

                    <div className={`col-6 mb-3 p-0 pe-2`}>
                        <label className="form-label text-form-title p-0">تاریخ انقضا</label>
                        <LocalizationProvider dateAdapter={AdapterDateFnsJalali} >
                            <DesktopDatePicker
                                components={{
                                    openPickerIcon: CalenderIcon,
                                }}
                                sx={{"&.MuiInputBase-root":{borderRadius:"10px",height:"44px",direction:"ltr"}}}
                                className={` ${ dateToError !== "" ? "input-br-error" : ""}`}
                                slotProps={{
                                    textField:{fullWidth:true,size:"small",sx:{borderRadius:"10px","& .MuiInputBase-root":{borderRadius:"10px",height:"44px"}}}}}  value={dateTo}
                                onChange={(newValue) => {
                                    setDateToError("")
                                    setDateTo(newValue)
                                }} />
                        </LocalizationProvider>
                        {dateToError && <InputError message={dateToError} show={dateToError.length > 0} />}
                    </div>

                </div>

                <div className={`row mx-5 my-4 justify-content-between`}>
                    <button
                        className={`col-3 btn border p-0`}
                        style={{fontWeight: "600"}}
                        onClick={cancel}
                    >انصراف</button>
                    <button className={`col-8 btn btn_discount py-2 p-0`} onClick={onSubmit}>
                        {
                            editable ? "به روز رسانی کد تخفیف" : "افزودن کد تخفیف"
                        }
                        </button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}